import { Link  } from 'react-router-dom';
import '../styles/auth.css'
import AuthForm from '../components/AuthForm';

const Login = () => {

  return (
    <main className="auth-container">
      <h2>Welcome back</h2>
      
        <AuthForm type="logIn" />

      <p>Don't have an account? <Link to="/register">Sign up</Link></p>
    </main>
  );
};

export default Login;